import { render, staticRenderFns } from "./alertImg.vue?vue&type=template&id=8d3f2dca&scoped=true"
import script from "./alertImg.vue?vue&type=script&lang=js"
export * from "./alertImg.vue?vue&type=script&lang=js"
import style0 from "./alertImg.vue?vue&type=style&index=0&id=8d3f2dca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3f2dca",
  null
  
)

export default component.exports